<template>
  <div class="stateBox">
    <m-loader size="box" :show="Object.keys(states).length === 0" />
    <span v-for="item in states" @click="toggleGeo(item)" class="state">
      <span :class="{ activite: getIsSelected(item.code) }">
        {{ item.name }}</span>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    geoType: {
      type: Number
    },
    changeGeoType: {
      type: Number,
      default: 2
    }
  },
  created() {
    this.$store.dispatch('geo/getStates')
  },
  computed: {
    realgeoType() {
      return this.$store.state.geo.geoTypes.State
    },
    states() {
      return this.$store.state.geo.states
    }
  },
  methods: {
    toggleGeo(item) {
      if (this.getIsSelected(item.code)) {
        this.$store.commit('order/deleteGeo', item.code)
      } else {
        this.$store.dispatch('order/changeGeoType', this.changeGeoType)
        this.$store.commit('order/addGeo', {
          GeoKeyCode: item.code,
          GeoKeyDesc: item.name,
          GeoType: 2
        })
      }
    },
    getIsSelected(code) {
      let orderGeos = this.$store.state.order.OrderGeos
      for (let key of Object.keys(orderGeos)) {
        if (code === orderGeos[key].GeoKeyCode) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.state {
  width: 25%;
  color: $color-text-grey;
  cursor: pointer;
  margin-top: 2px;
}

@media(max-width: 768px) {
  .state {
    width: 50%;
  }
}

.header {
  display: flex;
  justify-content: space-between;
}

.activite {
  color: $color-primary;
  box-sizing: border-box;
  background: $color-primary;
  color: $color-white;
  border: 1px solid $color-primary;
  border-radius: 5px;
  padding-right: 5px;
  padding-left: 5px;
  margin-top: 1px
}


.dbox {
  border: 1px solid $color-border;
  border-radius: 8px;
  background-color: $color-background;
  padding: 16px;
  width: 100%;
  margin-bottom: 16px;
}

.stateBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start
}
</style>




// WEBPACK FOOTER //
// src/Components/geo/MStateList.vue